import { createFileRoute } from '@tanstack/react-router'
import { MarketingPage } from '@/features/marketing/components/marketing-page'
import { frContent } from '@/features/marketing/content'

export const Route = createFileRoute('/fr/faq')({
  component: FrFaqPage,
})

function FrFaqPage() {
  return <MarketingPage {...frContent.faq} />
}
